var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M30,0A30,30,0,1,0,60,30,30.033,30.033,0,0,0,30,0Zm0,55.352A25.352,25.352,0,1,1,55.352,30,25.382,25.382,0,0,1,30,55.352Z",
    fill: "#b9ab9d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(16.195 20.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M165.271,190.742l-11.619-11.619a2.323,2.323,0,0,0-3.277,0l-11.619,11.619a2.324,2.324,0,0,0,3.277,3.276L152,184.049l9.992,9.969a2.317,2.317,0,1,0,3.277-3.277Z",
    transform: "translate(-138.197 -178.446)",
    fill: "#b9ab9d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.72cfc2dd67869f574063822ea1bef12e.svg";
export { ForwardRef as ReactComponent };